import React from 'react';
import { Dispatch } from 'redux';
import { connect } from "react-redux";
import { IApplicationState, RootActionCreators } from '../../../store';
import { createStyles, makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../organisms/PageHeader';
import { AutomaticTaskNavigation, AutomaticTaskNavigationPage, INavigations, mapNavigationsToProps } from '../../organisms/automatictask/AutomaticTaskNavigation';
import { IReportData } from "../../../entities/reports/IReportData";
import {IData as AutomaticTaskListData} from "../../../store/automatictask/AutomatictaskList";
import { FetchState } from '../../../entities/FetchState';
import { AutomaticTaskList as AutomaticTaskListOrganism } from '../../organisms/automatictask/AutomaticTaskList';

// CSS
const useStyles = makeStyles((theme: Theme) =>
    createStyles({}),
); 

// Standard Properties from parent component
interface IProps { }

// Outgoing functions to parent component
interface IDispatch {}

// Properties from State 
interface IStateProps {
    list: IReportData<AutomaticTaskListData>;
}
const mapStateProps = (state: IApplicationState): IStateProps => ({
    list: state.automatictask.automatictaskList.AutomaticTaskList,
});

// Outgoing functions to Dispatch
interface IDispatchProps {
    navigations: INavigations;
    onLoadList: () => void;
    onClickDetails: (id: string) => void,
    onClickEdit: (id: string) => void,
}
const mapDispatchProps = (dispatch: Dispatch): IDispatchProps => ({
    navigations: mapNavigationsToProps(dispatch),
    onLoadList: () => dispatch(RootActionCreators.Automatictask.automatictaskList.FetchData()),
    onClickDetails: (id: string) => dispatch(RootActionCreators.Navigate.ToAutomaticTaskDetail(id)),
    onClickEdit: (id: string) => dispatch(RootActionCreators.Navigate.ToAutomaticTaskEdit(id)),
});

// Actual Component
export type AllProps = IProps & IDispatch & IStateProps & IDispatchProps;
export const AutomaticTaskList = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tAutomaticTask } = useTranslation('automatictask');

    const refresh = () => { 
        props.onLoadList();
    }
    
    // Load the list when the component mounts or when the list state is NotFetched
    React.useEffect(() => {
        refresh();
    }, []);

    return <AutomaticTaskNavigation selected={AutomaticTaskNavigationPage.List} navigations={props.navigations}>
            
        <PageHeader
            title={tAutomaticTask('title')}
            subTitle={tAutomaticTask('subtitle')}
            explainText={tAutomaticTask('explainText')}
        />

        <AutomaticTaskListOrganism
            data={props.list.data}
            loading={props.list.state !== FetchState.Success && props.list.state !== FetchState.Error}
            hasError={props.list.state === FetchState.Error}
            errorDetails={props.list.errorMessage}
            onClickDetails={props.onClickDetails}
            onClickEdit={props.onClickEdit}
            onRefresh={refresh}
            title={tAutomaticTask('listTitle')}
        />

        </AutomaticTaskNavigation>
};

export default connect(mapStateProps, mapDispatchProps)(AutomaticTaskList);
